<script setup>
import { defineProps} from "vue";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Job {{ props?.dado?.codigo }}

            </h3>

            <div
                class="c-header__medidores"
            >

                <div class="c-medidor .c-medidor--valor-job">

                    <v-chip class="c-medidor__chip"
                        color="primary"
                        dark
                        label
                    >

                        {{ props?.dado?.status }}

                    </v-chip>

                </div>

                <div class="c-medidor .c-medidor--valor-na-previsao">

                    <v-chip class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        Valor do Job:
                        {{UtilMoney.toR$BRL(props?.dado?.valorAtual)}}

                    </v-chip>

                </div>

            </div>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Solicitacao de Orçamento"
                        :value="props?.dado?.solicitacaoDeOrcamentoCodigo"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Tipo de Equipamento"
                        :value="props?.dado?.solicitacaoDeOrcamentoTipoDeEquipamentoDescricao"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Data de Abertura"
                        :value="props?.dado?.dataAberturaFormatada"
                        prepend-icon="mdi-calendar" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Data de Entrega Contrutual"
                        :value="props?.dado?.dataEntregaContratualFormatada"
                        prepend-icon="mdi-calendar" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Data de Encerramento"
                        :value="props?.dado?.dataEncerramentoFormatada"
                        prepend-icon="mdi-calendar" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Comercial"
                        :value="props?.dado?.comercialNome"
                        prepend-icon="mdi-account" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Gestor de Contrato"
                        :value="props?.dado?.gestorNome"
                        prepend-icon="mdi-account" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Coordenador de Contratos"
                        :value="props?.dado?.coordenadorNome"
                        prepend-icon="mdi-account" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <v-text-field class="c-campo__input"
                    label="NCM"
                    :value="props?.dado?.ncmDescricaoCompleta"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: max-content 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo medidores";
}

.c-titulo {
    grid-area: titulo;
}

.c-header__medidores{
    grid-area: medidores;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
}

.c-conjunto-de-campos{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 0px 20px;
}

@media (width <= 650px) {

    .c-cartao__titulo{
        display: grid; 
        grid-template-columns: 1fr; 
        grid-template-rows: 1fr 1fr; 
        grid-template-areas: 
            "titulo"
            "medidores";
    }

}

</style>